import { JsonRestApiRequestConfig, makeJsonRestApiRequest } from '~src/httpClient/RestApiService';

import { ApiTokenResponse } from '../service/ScimConfigService';

export function createApiTokenRequestConfig(scimConfigId: string): JsonRestApiRequestConfig {
  return {
    restApiVersion: '3.27',
    httpMethod: 'POST',
    endpoint: `scimConfig/${scimConfigId}/apiToken`,
    serverWideRequest: false
  };
}

export function callCreateApiTokenRequest(scimConfigId: string): Promise<ApiTokenResponse> {
  return makeJsonRestApiRequest<null, ApiTokenResponse>({
    config: createApiTokenRequestConfig(scimConfigId),
    request: null
  });
}